import { useState, useEffect } from 'react';

function useLocalStorage<T>(key: string, initialValue: T) {

  function isValidJsonString(str: string) {
    try {
      JSON.parse(str);
      // If JSON.parse() successfully parses the string, it's valid JSON.
      return true;
    } catch (e) {
      // If JSON.parse() throws a SyntaxError, the string is not valid JSON.
      return false;
    }
  }

  
  // Use a function to initialize state from localStorage
  const [value, setValue] = useState(() => {
    try {
      const storedValue = window.localStorage.getItem(key);
      
      if(storedValue) {
        if(isValidJsonString(storedValue)) {
          return JSON.parse(storedValue);
        } else {
          return storedValue;
        }
      }
      
      return initialValue;
    } catch (error) {
      console.log(error);
      return initialValue;;
    }
  });

  // Update localStorage whenever the state value changes
  useEffect(() => {
    try {
        const storageValue = typeof value === 'object' ? JSON.stringify(value) : String(value);
        window.localStorage.setItem(key, storageValue);
    } catch (error) {
        if (error instanceof DOMException &&
            (error.name === 'QuotaExceededError' || error.name === 'NS_ERROR_DOM_QUOTA_REACHED')
          ) {
            console.warn(`localStorage quota exceeded while setting ${key}.`);
          } else {
            console.error(`Error setting '${key}' in localStorage:`, error);
          }
    }
  }, [key, value]);

  return [value, setValue];
}

export default useLocalStorage;
